/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Alert } from '@mui/material';
import { ApiService } from '../../services/apiService';
import { ApiCostsDataResponse } from '../../types/api';
import { CostsChartView } from './ChartView';

const apiService = new ApiService();

export const CostsChartLoader: React.FC<{hidden?: boolean}> = ({hidden}) => {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState<ApiCostsDataResponse | null>(null);
  const [dataByDay, setDataByDay] = useState<ApiCostsDataResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const token = searchParams.get('token') || '';
  const moduleId = searchParams.get('moduleId') || '';
  const userId = parseInt(searchParams.get('userId') || '');
  const activityId = parseInt(searchParams.get('activityId') || '');
  const [period, setPeriod] = useState<"all" | "year" | "day" | "week">('week');


  useEffect(() => {
    if (hidden) {
      return;
    }
    if (period === 'week' && !data) {
      loadDataByWeek();
    } else if (period === 'day' && !dataByDay) {
      loadDataByDays();
    }
  }, [token, moduleId, activityId, period, hidden]);


  const loadDataByWeek = async () => {
    try {
      setLoading(true);
      setError(null);

      if (!token || !moduleId) {
        throw new Error('Faltan parámetros requeridos: token y moduleId');
      }

      apiService.setAuth(token, moduleId);
      
      const response = await apiService.getCostsByWeekData(
        activityId,
        userId
      );
      
      setData(response);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error cargando datos');
    } finally {
      setLoading(false);
    }
  };

  const loadDataByDays = async () => {
    try {
      setLoading(true);
      setError(null);

      if (!token || !moduleId) {
        throw new Error('Faltan parámetros requeridos: token y moduleId');
      }

      apiService.setAuth(token, moduleId);
      
      const response = await apiService.getCostsData(
        activityId,
        userId,
      );
      
      setDataByDay(response);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error cargando datos');
    } finally {
      setLoading(false);
    }
  };

  if (hidden) {
    return <></>
  }

  if (loading) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        Cargando datos...
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">
          Error: {error}
        </Alert>
      </Box>
    );
  }
  
  const finalData = period === 'week' ? data : dataByDay;

  return (
    
    <Box sx={{ width: '100%', margin: '0 auto', padding: '0 !important' }}>
      {!finalData
        ? (
          <Box sx={{ p: 2 }}>
            <Alert severity="warning">No se encontraron datos</Alert>
          </Box>
        ) : (
          <CostsChartView data={finalData} period={period} setPeriod={setPeriod} />
        )
      }
    </Box>
  );
};